import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchProductById } from "../../store/product-slice";
import { useDispatch, useSelector } from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import { getDetailData } from "../../models/productModel";
import {getValidatedLimit} from "../../components/Utility";

const ProductDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.product);
    const {limit, currentPage} = getValidatedLimit(pagination);


    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchProductById(
            {
                ...userRole,
                id: params.productId
            }
        ));
    }, [dispatch, params.productId,userRole]);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.product);

    const item = items.find(item => item.id === params.productId);
    const detailData = getDetailData({ item });

    return (
        <>
            <SubHeader title="Product Details">
                <Button to={`../?page=${currentPage}&limit=${limit}`} className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{ lg: 9, xl: 7 }} data={detailData} />}
            </div>
        </>
    );
};

export default ProductDetail;
